import gql from 'graphql-tag';

export default gql`
  fragment FragmentAppUser on AppUser {
    appUserId
    name
    email
    createAt
    createBy
    uId
    __typename
  }
`;
